(($) => {$(() => {

  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', {
        'send_to': 'AW-995323189/FsuYCNaOg2QQtdrN2gM',
        'event_callback': callback,
        'non_interaction': true
    });
    return false;
  }
           
  $('#contactform_submit').click(function() {
            $('#contact_form').css('opacity', '0.5');
  			var _formData = {};
            $('#contact_form input, #contact_form textarea, #contact_form select').each(function() {
                _formData[$(this).attr('name')] = $(this).val();
            });
    	    //_formData['__gaUserId'] = __gaUserId;
            let fetchOptions = {
              method: 'POST',
              body: JSON.stringify(_formData),
            };
            appRequest(`/customer/email/contact`, fetchOptions)
              .then(response => response.json())
              .then(json => {
              	let interest = $('select[name="interest"]').val(),
                    url = '/pages/contact-us-success';
                if (interest == 'sales_question') {
              	  gtag_report_conversion(url);
                }
                else {
                  window.location = `${url}?interest=${interest}`;
                }
              	$('#contact_form').css('opacity', '1');
              })
              .catch(error => {
                console.log(error);
              });
            return false;
        });
  
})})(jQuery);
